import { convenioController, ConvenioViewProps, mapDispatchToConvenioProps, mapStateToConvenioProps } from "./convenio.controll"
import { Convenio } from "./convenio.model"
import ViewCad from "../../../view";
import { GridColDef } from "@mui/x-data-grid";
import { useEffect } from "react";
import { Select as ViewList } from "../../../components/select";
import { Box, Typography } from "@mui/material";
import { connect } from "react-redux";
import Modal from "../../../components/modal";
import store from "../../../store";


interface ConvenioCadProps extends ConvenioViewProps {
    handleCloseView: () => any
}

function ConvenioCad(props: ConvenioCadProps) {
    const { convenioActions, convenioState, handleCloseView } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status } = convenioState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue } = convenioActions

    const handleNovo = () => {
        setClearValue();
    }

    const handleExcluir = (row: Convenio) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: Convenio) => {
        const errors: any = {}
        if (!values.descricao)
            errors.nome = "Informe a descrição do convênio"
        return errors
    }

    const handleUpdate = (value: Convenio) => {
        if (!value._rev) {
            create(value);
        } else {
            update(value);
        }
        handleCloseView();
    }

    var viewCad = new ViewCad({
        formTitle: "Cadastro de convênios",
        formFieldDescription: "descricao",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: true,
            title: "Adicionar novo convênio",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        contentForm: [
            { fieldName: "descricao", label: "Descrição", type: "text", key: "descricao", colunsXS: 8, colunsSM: 8, colunsMD: 8, require: true },
            { fieldName: "ativo", label: "Ativo?", type: "checkbox", key: "ativo", colunsXS: 4, colunsSM: 4, colunsMD: 4, },
        ],
    })

    return viewCad
}


const columns: GridColDef[] = [
    { field: 'descricao', headerName: 'Descricão', flex: 8 },
    { field: 'ativo', headerName: 'Ativo?', flex: 4, renderCell: (prm) => prm.value ? "Sim" : "Não" },
]

function ConvenioViewFunc(props: ConvenioViewProps) {

    const { convenioActions, convenioState } = props
    const { error, loading, msg, row, rows, showAlert, showDialogExluir, status, showCadModal, changeList } = convenioState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue, setShowCadModal } = convenioActions

    const handleNovo = () => {
        setClearValue();
        setShowCadModal(true)
    }

    const handleAlterar = (row: Convenio) => {
        set(row);
        setShowCadModal(true)
    }

    const handleCloseCadastro = () => {
        setClearValue();
        setShowCadModal(false)
    }

    const List = (propsList: { handleOnClick: (row: Convenio) => any }) => {
        const { handleOnClick } = propsList
        return (
            <ViewList
                displayWidth={window.innerWidth}
                title={"Listagem de Convênios"}
                row={row}
                showAlert={showAlert}
                closeAlert={() => setShowAlert(false)}
                msg={msg}
                status={status}
                elevation={1}
                getRowId={(row) => row._id}
                handleOnChange={handleOnClick}
                actionsOnkeyEnter={handleOnClick}
                showSearchContainer={true}
                fontSize={20}
                setTextSearch={() => { }}
                textSearch={""}
                fieldSearch={"descricao"}
                columns={columns}
                rows={rows}
                loading={loading}
                setRow={handleOnClick}
                changeList={changeList}
                buttonNew={{
                    show: true,
                    onClick: handleNovo
                }}
                buttonRefresh={{
                    show: true,
                    onClick: () => read()
                }}
                ListItemTextPrimary={(row: Convenio) => <Typography component={"span"}>{row.descricao}</Typography>}
            />
        )
    }

    const Cadastro = () => {
        return ConvenioCad({
            ...props,
            handleCloseView: handleCloseCadastro
        }).renderModal({
            handleClose: handleCloseCadastro,
            show: props.convenioState.showCadModal,
            heigth: "auto",
            width: "sm"
        })
    }


    const View = (
        <Box>
            <List handleOnClick={handleAlterar} />
            <Cadastro />
        </Box>
    )
    return {
        View,
        List,
    }
}


const ConvenioCadModal = connect(mapStateToConvenioProps, mapDispatchToConvenioProps)(
    (props: ConvenioCadProps) => {
        const cadastro = ConvenioCad(props).renderModal({
            handleClose: props.handleCloseView,
            show: props.convenioState.showCadModal,
            heigth: "auto",
            width: "sm"
        })
    }
)

const ConvenioList = connect(mapStateToConvenioProps, mapDispatchToConvenioProps)(
    (props: ConvenioViewProps) => {
        useEffect(() => {
            props.convenioActions.read();
        }, [])
        return ConvenioViewFunc(props).View
    }
)

interface ConvenioSelectProps extends ConvenioViewProps {
    handleConvenioSelect: (row: Convenio) => any
}

const ConvenioSelect = connect(mapStateToConvenioProps, mapDispatchToConvenioProps)(
    (props: ConvenioSelectProps) => {
        
        const { rows,showSelectModal } = props.convenioState;

        useEffect(() => {
            if(showSelectModal && rows.length === 0)
                props.convenioActions.read();
        }, [])        

        return (
            <Modal
                component={ConvenioViewFunc(props).List({ handleOnClick: props.handleConvenioSelect })}
                handleClose={() => props.convenioActions.setShowSelectModal(false)}
                open={props.convenioState.showSelectModal}
                width="sm"
                heigth="auto"
                handleOnKeyDown={(ev) => {
                }}
            />
        )
    }
)

const handleShowConvenioSelect = (set: boolean) => {
    store.dispatch(convenioController.reducer.actions.setShowSelectModal(set))
}

export {
    ConvenioCadModal,
    ConvenioList,
    ConvenioSelect,
    handleShowConvenioSelect
}